import React from 'react';
import PageShell from '../components/page/PageShell';
import PageHeader from '../components/page/PageHeader';
import PageState from '../components/page/PageState';
import { useApp } from '../context/AppContext';
import RegulatoryLibraryView from '../components/regulatory/RegulatoryLibraryView';
import { canReadRegulatoryLibrary } from '../utils/regulatoryModel';

/**
 * Regulatory library (read-only) for Lead Advisor / Advisor / Company SPOC. The API returns published items only
 * and 403s a Company Delegate; the page mounts nothing (and sends no request) for any other persona.
 */
const RegulatoryLibraryPage = () => {
    const { user } = useApp();
    if (!canReadRegulatoryLibrary(user?.role)) {
        return <PageState status="empty" message="The Regulatory library is not available for your role." />;
    }
    return (
        <PageShell>
            <PageHeader title="Regulatory library" subtitle="Indian regulations with AI-drafted summaries that a ProLense administrator has checked against the official text" />
            <RegulatoryLibraryView />
        </PageShell>
    );
};

export default RegulatoryLibraryPage;
